<template>
  <v-container v-if="!loading" class="overflow-y-auto">
    <div v-if="!ffeFeedItems" class="d-flex justify-center align-center full-height">
      Pas de actualités sur le FFE
    </div>
    <div v-else>
      <v-row no-gutters>
        <v-col
          v-for="(item, index) in ffeFeedItems"
          :key="index"
          cols="4"
          class="pa-4"
        >
          <v-card
            max-width="344"
            class="mx-auto full-height d-flex flex-column"
          >
            <v-img
              :src="item.enclosure.url"
              height="200px"
              :aspect-ratio="1"
            />

            <v-card-title tag="p" style="height: 200px;" class="d-flex align-start">
              {{ item.title }}
            </v-card-title>

            <v-card-subtitle style="height: 30px;">
              {{ item.dateLabel }}
            </v-card-subtitle>

            <v-spacer />

            <v-card-actions>
              <v-btn
                color="third lighten-2"
                text
                @click="reddirectToFFE(item)"
              >
                En Savoir plus
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
  <div v-else class="d-flex justify-center align-center full-height">
    <Loader />
  </div>
</template>

<script>
import { onBeforeMount, ref, provide } from '@vue/composition-api';

import { format, fromUnixTime } from 'date-fns';
import { fr } from 'date-fns/esm/locale';
import { getFFeFeed } from '@/helpers/request';

import Loader from '@/components/common/Loader.vue';

export default {
  components: { Loader },
  setup () {
    const ffeFeedItems = ref([]);
    const loading = ref(false);

    onBeforeMount(async () => {
      loading.value = true;
      const response = await getFFeFeed();

      if (response.success) {
        ffeFeedItems.value = response.data.map(item => ({
          ...item,
          dateLabel: format(new Date(item.pubDate), 'dd/MM/yyyy')
        }));
      }

      loading.value = false;
    });

    const reddirectToFFE = item => {
      window.open(
        item.link,
        '_blank'
      );
    };

    return { loading, ffeFeedItems, reddirectToFFE };
  }
};

</script>

<style scoped>

.v-main__wrap {
  overflow-y: scroll;
}
</style>
